import { createSelector } from 'reselect'
import { STAGE_TASK_COUNTER, STAGE_BREAK_COUNTER } from 'constants'
import { happeningNow, minutes } from 'utils/timer'

export const usersObject = state => state.firebase.data.users || {}

export const usersArray = createSelector(usersObject, obj => Object.values(obj))

export const usersTodayObject = state => state.firebase.data.usersToday || {}

export const usersTodayArray = createSelector(usersTodayObject, obj =>
  Object.values(obj)
)

export const taskingTodayArray = createSelector(usersTodayArray, arr =>
  arr.filter(user => user.stage === STAGE_TASK_COUNTER)
)

export const taskingNowArray = createSelector(taskingTodayArray, arr =>
  arr.filter(user => happeningNow(user.lastSeen, minutes(25)))
)

export const breakingTodayArray = createSelector(usersTodayArray, arr =>
  arr.filter(user => user.stage === STAGE_BREAK_COUNTER)
)

export const breakingNowArray = createSelector(breakingTodayArray, arr =>
  arr.filter(user => happeningNow(user.lastSeen, minutes(5)))
)



// WEBPACK FOOTER //
// ./src/selectors/index.js